import { dateformat } from '../../components/common/Helpers'
import AvatarImage from '../../components/common/ui/avatars/AvatarImage'
import AvatarPlaceholder from '../../components/common/ui/avatars/AvatarPlaceholder'
import FlowerSvg from '../../components/common/ui/assets/FlowerSvg'

export default function ObituaryItem({ obituary, photoShape, target, showFlowersButton, showFlowersIcon }) {

    return (
        <li className="col-span-1 flex flex-col justify-between text-center overflow-hidden relative obituary-card obituary-gallery-card">
            <a href={obituary.public_url} target={target}>
                {obituary.default_image_sizes
                    ? <AvatarImage url={obituary.default_image_sizes.sm} className={"mx-auto object-cover obituary-photo obituary-gallery-photo"} ring={false} round={photoShape == 'circle'} size={28} />
                    : <AvatarPlaceholder className={"mx-auto obituary-photo obituary-gallery-photo"} round={photoShape == 'circle'} size={28} />
                }
                <h3 className="mt-2 text-gray-900 text-sm font-medium obituary-name obituary-gallery-name">{obituary.display_name}</h3>

                {obituary.date_of_death !== null && obituary.show_date_of_death &&
                    <dl className="mt-1 flex-grow flex flex-col justify-between obituary-date-container obituary-gallery-date-container">
                        <dd className="text-gray-500 text-sm obituary-date obituary-gallery-date">{dateformat(obituary.date_of_death)}</dd>
                    </dl>
                }
            </a>
            {showFlowersButton === 'true' && obituary.flower_sales_url && (
                <a href={obituary.flower_sales_url} target={target}>

                    <button className="px-3 py-1 border rounded-md border-blue-600 text-blue-600 obituary-flowers-button obituary-gallery-flowers-button">
                        <div className="flex items-center obituary-flowers-inner obituary-gallery-flowers-inner">
                            {showFlowersIcon === 'true' && <FlowerSvg />}
                            <p className={`${showFlowersIcon === 'true' && 'ml-1'} obituary-flowers-text obituary-gallery-flowers-text`}>Send Flowers</p>
                        </div>
                    </button>
                </a>
            )}
        </li>
    )
}
